import axios from 'axios';
import urlJoin from 'url-join';

/**
 * Portfolio API service.
 */
export default class HabitationsService {
    /**
     * Retrieve habitations of current user.
     * @return {Promise<Object>} Estima information
     */
    static getHabitations() {
        return axios.get(urlJoin(MA.Config.WWW_URL, '/estimation-immobiliere/habitations/'), {
            headers: { Accept: 'application/json' },
        });
    }
}
